import { render, staticRenderFns } from "./EnergyPrice.vue?vue&type=template&id=aab4819e&scoped=true&"
import script from "./EnergyPrice.vue?vue&type=script&lang=js&"
export * from "./EnergyPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab4819e",
  null
  
)

export default component.exports